import React from 'react';
import PropTypes from 'prop-types';
import request from '../../utils/agent';
import { Formik, Field, FieldArray, Form } from 'formik';
import Loader from 'components/Loader';
import * as Yup from 'yup';
import './AdminCreateAdmin.scss';

export default class AdminCreateAdmin extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            role: 'admin',
            isError: false,
            isSubmited: false,
        };
    }

    componentDidMount() {

    }

    componentDidUpdate() {
        if(this.state.isSubmited === true) {
            this.setState({isSubmited: false});
        }
    }

    render(){

        const adminSchema = Yup.object().shape({
            email: Yup.string()
                .email('This value should be a valid email.')
                .required('This value is required.'),
            first_name: Yup.string()
                .required('This value is required.'),
            last_name: Yup.string()
                .required('This value is required.')
        });


        return(
            <section className='profile--container'>
                <div className='profile-data'>
                    <div className='short-desc'>
                        <h3>New Admin</h3>
                    </div>
                    {this.state.isSubmited === false ?
                        < div className='profile-details'>
                            <h3>Primary Contact Information</h3>
                            <Formik
                                initialValues={{
                                    email: "",
                                    first_name: "",
                                    last_name: "",
                                }}
                                validationSchema={adminSchema}
                                enableReinitialize={true}
                                onSubmit={(values, actions) => {
                                    return new Promise((resolve, reject)=> {
                                        request.post('/api/createcompany')
                                            .send({
                                                role: this.state.role,
                                                username: values.email,
                                                email: values.email,
                                                first_name: values.first_name,
                                                last_name: values.last_name,
                                                name: 0,
                                                coverage_range: 0,
                                                years_in_business: 0,
                                                number_of_employees: 0,
                                                experience_with_noon: false,
                                                dealer_finder: false,
                                                provide_staff_training: false,
                                            })
                                            .then(data => {
                                                actions.setSubmitting(false);
                                                console.log('finished call');
                                                console.log(data);
                                            })
                                            .then(resp => {
                                                this.setState({isSubmitted: true})
                                            })
                                            .catch(err => {
                                                console.error(err);
                                                this.setState({isError: true});
                                            });
                                    });
                                }}>

                                {({
                                      values,
                                      errors,
                                      touched,
                                      handleChange,
                                      handleBlur,
                                      handleSubmit,
                                      isSubmitting,
                                      handleReset,
                                      resetForm,
                                      dirty
                                  }) => (
                                    <Form className='my-f-form' onSubmit={handleSubmit}>
                                        <label className='form-f-label'>Email*</label>
                                        <Field
                                            name='email'
                                            className={errors.email && touched.email ? 'form-f-field with-error' : 'form-f-field'}
                                            component='input'
                                            type='text'
                                            placeholder='Email*'
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.email} />
                                        {errors.email && touched.email ?
                                            (<div className='f-field-errors'>{errors.email} </div>) : null
                                        }

                                        <div className='flex--fields--holder'>
                                            <div className='flex-field-container'>
                                                <label className='form-f-label'>First Name*</label>
                                                <div className='flex-with-error-holder'>
                                                    <Field
                                                        name='first_name'
                                                        component='input'
                                                        className=   {errors.first_name && touched.first_name ? 'form-f-field flex-with-error' : 'form-f-field'}
                                                        type='text'
                                                        placeholder='First Name*'
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        value={values.first_name}
                                                    />
                                                    {errors.first_name && touched.first_name ? (
                                                        <div className='f-field-errors'>{errors.first_name}</div>) : null
                                                    }
                                                </div>
                                            </div>

                                            <div className='flex-field-container last'>
                                                <label className='form-f-label'>Last Name*</label>
                                                <div className='flex-with-error-holder'>
                                                    <Field
                                                        name='last_name'
                                                        component='input'
                                                        className= {errors.last_name && touched.last_name ?'form-f-field flex-with-error': 'form-f-field'}
                                                        type='text'
                                                        placeholder='Last Name*'
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        value={values.last_name}
                                                    />
                                                    {errors.last_name && touched.last_name ?
                                                        (<div className='f-field-errors'>{errors.last_name}</div>): null
                                                    }
                                                </div>
                                            </div>
                                        </div>

                                        <button className='form-f-button' type="submit">
                                            Save
                                        </button>

                                    </Form>
                                )}

                            </Formik>
                        </div> :
                        <Loader/>
                    }
                </div>
            </section>
        )
    }
}


// WEBPACK FOOTER //
// ./src/routes/AdminCreateAdmin/index.js